'use strict'

import React from 'react';
import Layout from '../Layout.jsx';
import PresentationView from '../risk/PresentationView.jsx';
import {Risk} from '../Risk.jsx';
import priority from '../../app/utils/priority.js';

function assignPriority(item) {
  return item.status!=="Closed"
    ? Object.assign({},item,{row:parseInt(item.probability),column:parseInt(item.impact)})
    :  Object.assign({},item,{row:undefined,column:undefined});
}

export class PortfolioReportRiskOld extends React.Component {
  constructor(props) {
    super(props);
    var items=this.props.risks!==undefined ? this.props.risks : [];

    this.state={
      items:items,
      selected:props.selected
    };
  }


  render() {
    var items=this.state.items
      .slice(0)
      .map(assignPriority)
      .sort(priority.getProfileSort(this.props.profile));

    let reportStyle={textAlign:"left", maxWidth:1016};
    let style=Object.assign({},reportStyle,this.props.settings!==undefined ? this.props.settings.style : undefined);

    return (
      <div style={{paddingLeft:20, fontFamily: "Lato, Verdana, sans-serif"}}>
        <PresentationView {...this.props}
          items={items}
          selected={this.state.selected}
        />
      </div>
    )
  }
}

export class PortfolioReportRisk extends React.Component {
  constructor(props) {
    super(props);
    var items=this.props.risks!==undefined ? this.props.risks : [];

    this.state={
      items:items,
      selected:props.selected
    };
  }


  render() {
    var items=this.state.items
      .slice(0)
      .map(assignPriority)
      .sort(priority.getProfileSort(this.props.profile));

    let reportStyle={textAlign:"left", maxWidth:1016};
    let style=Object.assign({},reportStyle,this.props.settings!==undefined ? this.props.settings.style : undefined);

    return (
      <div style={{paddingLeft:20, fontFamily: "Lato, Verdana, sans-serif"}}>
        <Risk {...this.props}
          items={items}
          selected={this.state.selected}
          view="presentOnly"
        />
      </div>
    )
  }
}


export default class PortfolioReportRiskPage extends React.Component {
  render() {
    return (
      <Layout {...this.props}>
        <PortfolioReportRisk {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/portfolio/ReportRisk.jsx